export const TRUST_SOFTPHONE_PREFIX = 'trusttel://0'

export const prefixPlusSignIfLongerThan9Digits = (phoneNumber) =>
	`${TRUST_SOFTPHONE_PREFIX}${
		phoneNumber.length > 9 ? `+${phoneNumber}` : phoneNumber
	}`
